goog.provide('el8.app.settings.docTags');

goog.require('el8.app.shared.dialog.addEditDocTag');
goog.require('el8.data.docTags');
goog.require('el8.template.app.settings.docTags');
goog.require('el8.uiwidget.CuratedList');
goog.require('el8.util.consts');


el8.app.settings.docTags = (function() {
    var that;

    that = {
        init: function($container) {
            var $content = $(el8.template.app.settings.docTags.content({}));
            $container.html($content).show();
            setupDocTagsList($container);
            bindTriggers($container);
        },
        _curatedList: null
    };

    function setupDocTagsList($container) {
        var curatedList;

        curatedList = new el8.uiwidget.CuratedList({
            entitySet: el8.data.docTags,
            customDeleteFn: function(docTag) {
                var confirmMsg = "Are you sure you want to permanently delete this document tag?";
                el8.uiwidget.confirm(confirmMsg, function() {
                    el8.data.docTags.deleteItem(docTag);
                });
            },
            customValidationFn: function(form) {
                if (form.getVal('code') && !form.getVal('codeType') ||
                    !form.getVal('code') && form.getVal('codeType')) {
                        el8.uiwidget.alert('Coded tags must have both a code and a code type.');
                        return false;
                }
                return true;
            },
            itemDescriptionStr: 'document tag',
            container: $('.doc-tags-section', $container),
            listSelector: '.doc-tags-list',
            sortable: false,
            listTemplateFn: function() {
                return el8.template.app.settings.docTags.list({
                    docTags: el8.data.docTags.allAsSoyMaps(),
                    isPracticeAdmin: el8.data.currUser.isPracticeAdmin()
                });
            },
            formTemplateFn: function() {
                return el8.template.app.settings.docTags.form({
                    codeTypes: el8.util.consts.DOC_TAG_CODE_TYPES
                });
            },
            fieldSpec: [
                {
                    name: 'value',
                    selector: ':input[name="value"]',
                    infoText: 'Label',
                    height: el8.util.consts.DEFAULT_FIELD_HEIGHT,
                    maxLength: 100,
                    validate: { required: true }
                },
                {
                    name: 'description',
                    selector: ':input[name="description"]',
                    infoText: 'Description',
                    height: el8.util.consts.DEFAULT_FIELD_HEIGHT,
                    maxLength: 500
                },
                {
                    name: 'code',
                    selector: ':input[name="code"]',
                    infoText: 'Code',
                    height: el8.util.consts.DEFAULT_FIELD_HEIGHT,
                    maxLength: 50,
                    mindreaderOpts: el8.appshared.mindreaderOpts.icd9Codes()
                },
                {
                    name: 'codeType',
                    selector: ':input[name="codeType"]',
                    infoText: 'Code Type',
                    height: el8.util.consts.DEFAULT_FIELD_HEIGHT,
                    maxLength: 10
                }
            ]
        });

        that._curatedList = curatedList.init();
    }

    function bindTriggers($container) {
        $container.on('change', ':input[name="codeType"]',  function(event) {
            var form = that._curatedList.getForm();
            if (form.getVal('codeType') === 'ICD9') { form.getMindreader('code').enable(); }
            else { form.getMindreader('code').disable(); }
        });
    }


    return that;

})();
